import React from "react";
import useToggleLanguage from "./useToggleLanguage";
import "./style.css";

const languages = [
  { value: "en", label: "EN" },
  { value: "ar", label: "العربية" },
];

const Arrow = () => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L6 5L11 1"
      stroke="#1890FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LangPicker = ({ className = "" }) => {

  const { lang, switchLanguage } = useToggleLanguage();
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  const isRTL = lang === "ar";
  const selected = languages.find(l => l.value === lang);

  // ✅ close on outside click / touch
  React.useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("pointerdown", handler);
    return () => document.removeEventListener("pointerdown", handler);
  }, []);

  const toggleOpen = e => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(o => !o);
  };

  const handleSelect = value => {
    switchLanguage(value);
    setOpen(false);
  };

  return (
    <div
      ref={ref}
      dir={isRTL ? "rtl" : "ltr"}
      className={`relative inline-block w-24 ${className}`}
    >
      {/* Trigger */}
      <button
        type="button"
        onClick={toggleOpen}
        onTouchStart={toggleOpen}
        className="
          px-5 py-3
          flex items-center justify-between w-full
          rounded-lg bg-theme-blue-light
          font-bold text-black
          focus:outline-none
          select-none
        "
      >
        <span>{selected?.label}</span>
        <div className="transition-all duration-200" style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>
          <Arrow />
        </div>
      </button>

      {/* Dropdown */}
      {open && (
        <div
          className="
            absolute z-50 mt-2 w-full
            rounded-lg bg-theme-blue-light
            shadow-lg overflow-hidden
          "
        >
          {languages.map(item => (
            <button
              key={item.value}
              type="button"
              onClick={() => handleSelect(item.value)}
              onTouchStart={() => handleSelect(item.value)}
              className={`
                w-full px-4 py-2 text-sm font-bold
                text-black text-start
                hover:bg-blue-300
                active:bg-blue-200
                ${item.value === lang ? "bg-blue-200" : ""}
              `}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangPicker;
